import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {process.env.NODE_ENV !== 'production' && (
      <div role="status" style={{background:'#fff3cd',color:'#533f03',padding:'8px 12px',
        textAlign:'center',font:'13px system-ui',borderBottom:'1px solid #e1cc8a'}}>
        Ambiente de teste local — sem Firebase de produção. Webhook somente com início manual.
      </div>
    )}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
